"use client";

import React from "react";
import { IoMail } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";
import {
  FaFacebook,
  FaTiktok,
  FaYoutube,
  FaInstagramSquare,
  FaPhoneAlt,
  FaClock
} from "react-icons/fa";
import Link from "next/link";
import pkg from "../../package.json";
import useCMS from "@/utils/hooks/useCMS";
import BrandLogo from "@/components/BrandLogo";

function Footer() {
  const { cmsData } = useCMS("VARIABLES");

  return (
    <div className="bg-dark-base py-8">
      <div className="container mx-auto flex h-auto flex-col items-center px-4 text-white">
        <div className="flex w-full flex-1 flex-col items-center justify-between gap-4 py-2 text-xs md:flex-row lg:text-xs">
          <div className="space-y-4">
            <BrandLogo
              logo="KLIK_LOGO_WHITE"
              fallback="/images/logo.png"
              className="max-h-14 max-w-[350px]"
            />
            <p className="w-fit rounded-sm bg-fill px-1 font-medium text-dark-4">
              Version {pkg.version}
            </p>
          </div>

          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2 rounded-md p-1 transition-all duration-300 hover:bg-fill hover:text-dark-base">
              <FaPhoneAlt />
              <p>{cmsData?.HOTLINE_1 ?? "+63 9276544218"}</p>
            </div>
            <div className="flex items-center gap-2 rounded-md p-1 transition-all duration-300 hover:bg-fill hover:text-dark-base">
              <FaClock />
              <p>{cmsData?.HELPDESK_SCHEDULE_1 ?? "Mon - Fri, 8:00AM - 5:00PM"}</p>
            </div>
            <div className="flex items-center gap-2 rounded-md p-1 transition-all duration-300 hover:bg-fill hover:text-dark-base">
              <IoMail />
              <p>{cmsData?.EMAIL ?? "informtalibon@gmail.com"}</p>
            </div>
            <div className="mt-5 flex w-full flex-1 items-center justify-around">
              <Link
                href="https://www.facebook.com/TalibonOfficialPage/"
                target="_blank"
                className="text-sm md:text-base"
              >
                <FaFacebook className="cursor-pointer hover:text-primary-base" />
              </Link>
              <Link href="/" target="_blank" className="text-sm md:text-base">
                <FaXTwitter className="cursor-pointer hover:text-primary-base" />
              </Link>
              <Link href="/" target="_blank" className="text-sm md:text-base">
                <FaTiktok className="cursor-pointer hover:text-primary-base" />
              </Link>
              <Link href="/" target="_blank" className="text-sm md:text-base">
                <FaYoutube className="cursor-pointer hover:text-primary-base" />
              </Link>
              <Link href="/" target="_blank" className="text-sm md:text-base">
                <FaInstagramSquare className="cursor-pointer hover:text-primary-base" />
              </Link>
            </div>
          </div>
        </div>
        <div className="my-8 h-[1px] w-full bg-dark-3" />
        <div className="flex w-full flex-col items-center justify-between py-2 text-xs md:flex-row lg:text-xs">
          <div className="flex flex-1 justify-center text-center md:items-center md:justify-start">
            Copyright &#169; 2024 {cmsData?.LGU_NAME ?? "Municipality of Talibon"} All Rights
            Reserved.
          </div>
          <ul className="mt-6 flex flex-col items-center gap-4 md:mt-0 md:flex-row">
            <li className="cursor-pointer hover:text-primary-base">
              <Link href={process.env.NEXT_PUBLIC_WEBSITE_PORTAL_URL}>Visit Talibon E-News</Link>
            </li>
            <li className="cursor-pointer hover:text-primary-base">
              <Link href="/e-services/contact-us">Contact Us</Link>
            </li>
            <li className="cursor-pointer hover:text-primary-base">
              <Link href="/e-services/about-us">About Us</Link>
            </li>
            {/* <li className="cursor-pointer hover:text-primary-base">Privacy Policy</li>
            <li className="cursor-pointer hover:text-primary-base">Terms of Use</li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Footer;
